import React, { useMemo, useState, useEffect, useCallback } from "react";
import Swal from "sweetalert2";
import { useAuth } from "../../../authentication/authHelpers";
import { useActivity } from "../../../hooks/useActivity";
import PagatGrid from "../PagatGrid";
import EmployeeWageView from "./employee/EmployeeWageView";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { promptPagatPin } from "../../../utils/promptPagatPin";
import {
  isPagatPinUnlocked,
  setPagatPinUnlocked,
} from "../../../utils/getCurrentUserPin";
import LoadableComp from "../../commonComponents/LoadableComp/LoadableComp";
import { isBranchManager } from "../../../utils/branchScope";

function MainWage() {
  const { userRole, user, userAccess } = useAuth();
  const activity = useActivity(300000); // 1s=1000ms
  const navigate = useNavigate();
  const { isDarkMode, users } = useSelector((state) => state.usersList);
  const [pinReady, setPinReady] = useState(() => isPagatPinUnlocked());
  const [checkingPin, setCheckingPin] = useState(!isPagatPinUnlocked());

  const ensurePin = useCallback(async () => {
    if (isPagatPinUnlocked()) {
      setPinReady(true);
      setCheckingPin(false);
      return;
    }
    const authUser = user || userAccess?.[0];
    // Wait until we can resolve a PIN (auth user and/or users list).
    if (!authUser && (!users || (Array.isArray(users) && !users.length))) {
      return;
    }
    setCheckingPin(true);
    const ok = await promptPagatPin({
      users,
      authUser,
      isDarkMode,
    });
    if (ok) {
      setPinReady(true);
    } else {
      setPagatPinUnlocked(false);
      navigate("/kryefaqja");
    }
    setCheckingPin(false);
  }, [users, user, userAccess, isDarkMode, navigate]);

  useEffect(() => {
    if (pinReady) return;
    ensurePin();
  }, [ensurePin, pinReady]);

  useMemo(() => {
    if (!pinReady) return;
    if (activity === false) {
      let timerInterval;
      Swal.fire({
        title: `KUJDES!`,
        html: "Ju do te largoheni ne <b></b> sekonda!",
        customClass: {
          popup: isDarkMode ? "custom-swal-dark" : "custom-swal",
        },
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Qendro!",
        denyButtonText: `Me largo!`,
        confirmButtonColor: "#1da193",
        reverseButtons: true,
        timer: 15000,
        timerProgressBar: true,
        didOpen: () => {
          const b = Swal.getHtmlContainer().querySelector("b");
          timerInterval = setInterval(() => {
            b.textContent = parseInt(Swal.getTimerLeft() / 1000);
            if (Swal.getTimerLeft() / 1000 < 1) {
              setPagatPinUnlocked(false);
              navigate("/kryefaqja");
              clearInterval(timerInterval);
              Swal.close();
            }
          }, 100);
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "U ruajt me sukses!",
            icon: "success",
            customClass: {
              popup: isDarkMode ? "custom-swal-dark" : "custom-swal",
            },
          });
        } else if (result.isDenied) {
          setPagatPinUnlocked(false);
          navigate("/kryefaqja");
          Swal.fire({
            title: "Ju u larguat!",
            icon: "info",
            customClass: {
              popup: isDarkMode ? "custom-swal-dark" : "custom-swal",
            },
          });
        }
      });
    }
  }, [activity, pinReady, isDarkMode, navigate]);

  if (checkingPin || !pinReady) {
    return <LoadableComp loading />;
  }

  return (
    <>
      {userRole === "Admin" ||
      userRole === "Super Admin" ||
      isBranchManager(userRole) ? (
        <PagatGrid />
      ) : (
        <EmployeeWageView />
      )}
    </>
  );
}

export default MainWage;
